import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import moduleAuth from "./auth/moduleAuth.js";
import moduleECommerce from "./eCommerce/moduleECommerce.js";
import firebaseAuth from "./firebase/firebaseAuth";
import firebaseRealtime from "./firebase/firebaseRealtimeDB";
import firebaseStorage from "./firebase/firebaseStorage";
import uploadFile from "./upload-file/uploadFile";
import moduleCompanyConfig from "./company-config/moduleCompanyConfig";
import permissionsCheck from "./permissions-check/permissionsCheck";
import notification from "./notification/notification";
import moduleMap from "./map/moduleMap";
import moduleRoles from "./roles/moduleRoles";
import moduleSetting from "./setting/moduleSetting";
import modulePreferences from "./preferences/modulePreferences";
import moduleChat from "./chat/moduleChat.js";

export default new Vuex.Store({
	getters,
	mutations,
	state,
	actions,
	modules: {
		chat: moduleChat,
		auth: moduleAuth,
		eCommerce: moduleECommerce,
		firebaseAuth,
		firebaseRealtime,
		firebaseStorage,
		uploadFile,
		moduleCompanyConfig,
		permissionsCheck,
		notification,
		moduleMap,
		moduleRoles,
		moduleSetting,
		modulePreferences,
	},
	strict: process.env.NODE_ENV !== "production",
});
